function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_3"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "svg-fill-purple",
  d: "M11.01,3.15v7.01c0,0.55-0.45,1-1,1H3c-0.55,0-1-0.45-1-1V3.15c0-0.55,0.45-1,1-1h7.01 C10.56,2.15,11.01,2.6,11.01,3.15z M21.9,3.15v7.01c0,0.55-0.45,1-1,1h-7.01c-0.55,0-1-0.45-1-1V3.15c0-0.55,0.45-1,1-1h7.01 C21.46,2.15,21.9,2.6,21.9,3.15z M19.9,4.15h-5.01v5.01h5.01V4.15z M11.01,14.02v7.01c0,0.55-0.45,1-1,1H3c-0.55,0-1-0.45-1-1 v-7.01c0-0.55,0.45-1,1-1h7.01C10.56,13.02,11.01,13.47,11.01,14.02z M9.01,15.02H4v5.01h5.01V15.02z M21.9,14.02v7.01 c0,0.55-0.45,1-1,1h-7.01c-0.55,0-1-0.45-1-1v-7.01c0-0.55,0.45-1,1-1h7.01C21.46,13.02,21.9,13.47,21.9,14.02z M19.9,15.02h-5.01 v5.01h5.01V15.02z"
}));

var SvgIconDashboard = function SvgIconDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_dashboard.b1b7aabc.svg";
export { ForwardRef as ReactComponent };